import React from 'react';
import PrimaryButton from '../shared/PrimaryButton';
import SecondaryButton from '../shared/SecondaryButton';
import {
  PHONE_NUMBER,
  PHONE_NUMBER_LINK,
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
} from '../../data/contact';

const FinalCTA = () => (
  <section className="section">
    <div className="container">
      <div className="final-cta card">
        <div>
          <p className="section-eyebrow">Contact Preferred Service</p>
          <h2>Ready to get started?</h2>
          <p>
            Contact Preferred Service today for dependable heating and cooling support.
          </p>
        </div>
        <div className="hero-actions">
          <PrimaryButton to="/contact">{PRIMARY_CTA_TEXT}</PrimaryButton>
          <SecondaryButton href={PHONE_NUMBER_LINK} aria-label={`Call Now at ${PHONE_NUMBER}`}>
            {SECONDARY_CTA_TEXT}
          </SecondaryButton>
        </div>
      </div>
    </div>
  </section>
);

export default FinalCTA;
